import { createStore } from "vuex";
import { authPageModule } from "./auth-store/index.js";
import { feeTypePageModule } from "./feetype-store/index.js";
import { catePageModule } from "./cate-store/index.js";
import { docPageModule } from "./doc-store/index.js";
import { entPageModule } from "./ent-store/index.js";
import { empPageModule } from "./emp-store/index.js";
import { dashPageModule } from "@/store/dash-store";
import { allUserPageModule } from "@/store/bussiness-store";
import { reportPageModule } from "@/store/report-store";
import { provPageModule } from "@/store/prov-store";
import { deptPageModule } from "@/store/dept-store";
import { orgPageModule } from "./org-store/index.js";
export default createStore({
  state: {
    LoadingOverlay: false,
    snackbarSuccess: false,
    snackbarFailed: false,
    msg: "",
  },
  getters: {},
  mutations: {
    snackbarSuccess(state, value) {
      state.snackbarSuccess = value;
    },
    snackbarFailed(state, { value, msg }) {
      state.snackbarFailed = value;
      state.msg = msg;
    },
    LoadingOverlay(state, value) {
      state.LoadingOverlay = value;
    },
  },
  actions: {},
  modules: {
    reportPageModule,
    allUserPageModule,
    authPageModule,
    feeTypePageModule,
    catePageModule,
    docPageModule,
    entPageModule,
    empPageModule,
    dashPageModule,
    deptPageModule,
    provPageModule,
    orgPageModule,
  },
});
